export const mes = {

  title: "深圳心派科技有限公司",
  /*
  index
  */
  //提示
  exchange_tip_content: "确定切换语言吗",
  exchange_tip_title: "提示",
  exchange_tip_confirm_btn: "确定",
  exchange_tip_cancel_btn: "取消",
  //中英文
  index_top_zh_lang_tips: '中文',
  index_top_en_lang_tips: 'English',
  //主页面
  index_top_nav_1: "首页",
  index_top_nav_2: "移动设备",
  index_top_nav_3: "专网通信",
  index_top_nav_4: "人脸识别",
  index_top_nav_5: "企业资讯",

  index_bottom_nav_1: "最新产品",
  index_bottom_nav_1_1: "R800三防手机",
  index_bottom_nav_1_2: "F60翻盖功能机",
  index_bottom_nav_1_3: "MM750红点获奖产品",


  index_bottom_nav_2: "关于我们",
  index_bottom_nav_2_1: "企业简介",
  index_bottom_nav_2_2: "发展历程",
  index_bottom_nav_2_3: "合作伙伴",
  index_bottom_nav_2_4: "合作方式",
  index_bottom_nav_2_5: "质量认证",

  index_bottom_nav_3: "移动通信",
  index_bottom_nav_3_1: "智能机",
  index_bottom_nav_3_2: "三防机",
  index_bottom_nav_3_3: "翻盖机",
  index_bottom_nav_3_4: "直板机",


  index_top_nav_log_src: "../static/img/index/log.png",
  index_top_nav_footer_src: "../static/img/index/footer.jpg",
  //下拉
  index_top_1: "../static/img/index/top8.png",
  index_top_2: "../static/img/index/top9.png",
  //轮播
  index_swiper_1: '../../static/img/index/swiper01.jpg',
  index_swiper_2: '../../static/img/index/swiper02.jpg',
  index_swiper_3: '../../static/img/index/swiper03.jpg',
  index_swiper_4: '../../static/img/index/swiper04.jpg',
  //签名
  index_name_text: '../../static/img/index/Home_word1.png',
  //hover块
  index_unHover_1: '../../static/img/index/u55.png',
  index_hover_1: '../../static/img/index/u56.png',
  index_unHover_2: '../../static/img/index/u58.png',
  index_hover_2: '../../static/img/index/u59.png',
  index_unHover_3: '../../static/img/index/u61.png',
  index_hover_3: '../../static/img/index/u62.png',
  index_unHover_4: '../../static/img/index/u64.png',
  index_hover_4: '../../static/img/index/u65.png',
  index_unHover_5: '../../static/img/index/u67.png',
  index_hover_5: '../../static/img/index/u68.png',
  index_unHover_6: '../../static/img/index/u70.png',
  index_hover_6: '../../static/img/index/u71.png',
  index_unHover_7: '../../static/img/index/u73.png',
  index_hover_7: '../../static/img/index/u74.png',
  index_unHover_8: '../../static/img/index/u76.png',
  index_hover_8: '../../static/img/index/u77.png',
  index_four_content_img: '../../static/img/index/Home_word3.png',
  index_five_content_1_text: "../../static/img/index/Home_word4.png",
  index_five_content_2_text: "../../static/img/index/Home_word5.png",
  index_five_content_2_img: "../../static/img/index/Home_word6.png",
  index_five_content_3_img: "../../static/img/index/Home_word7.png",
  index_five_content_4_img: "../../static/img/index/Home_word8.png",
  index_five_content_5_img: "../../static/img/index/Home_word9.png",
  index_five_content_6_img: "../../static/img/index/Home_word10.png",
  index_five_content_7_img: "../../static/img/index/Home_word11.png",
  /*
  O12
  */
  first_content_1: '../../../static/img/ydtx/o12/O12_word1.png',
  first_content_2: '../../../static/img/ydtx/o12/O12_word2.png',
  first_content_3: '../../../static/img/ydtx/o12/O12_word3.png',

  o12_text_1: "亲情号码1",
  o12_text_2: "亲情号码2",
  o12_text_3: "亲情号码3",


  /*
  O21
  */
  o21_first_content_1: '../../../static/img/ydtx/o21/021_word1.png',
  o21_first_content_2: '../../../static/img/ydtx/o21/021_word1_2.png',
  o21_second_content_1: '../../../static/img/ydtx/o21/021_word2_1.png',
  o21_second_content_2: '../../../static/img/ydtx/o21/021_word2_2.png',
  o21_third_content_1: '../../../static/img/ydtx/o21/021_word3_1.png',
  o21_third_content_2: '../../../static/img/ydtx/o21/021_word3_2.png',

  /*
  O22
  */
  o22_first_content_1: '../../../static/img/ydtx/o22/022_word1.png',
  o22_first_content_2: '../../../static/img/ydtx/o22/022_word2.png',
  o22_second_content_1: '../../../static/img/ydtx/o22/022_word3.png',
  o22_six_content_0: '../../../static/img/ydtx/o22/022_word4.png',
  o22_seven_content_0: '../../../static/img/ydtx/o22/022_word5.png',
  o22_eight_content_0: '../../../static/img/ydtx/o22/022_word6.png',
  /*
  R700
  */
  r700_first_content_1: '../../../static/img/ydtx/r700/r700_word1.png',
  r700_first_content_2: '../../../static/img/ydtx/r700/r700_word2.png',
  r700_first_content_3: '../../../static/img/ydtx/r700/r700_word3.png',
  r700_second_content_1: '../../../static/img/ydtx/r700/r700_word4.png',
  r700_third_content_1: '../../../static/img/ydtx/r700/r700_word5.png',
  r700_four_content_1: '../../../static/img/ydtx/r700/r700_word6.png',
  r700_four_content_3: '../../../static/img/ydtx/r700/r700_word7.png',
  r700_five_content_1: '../../../static/img/ydtx/r700/r700_word8.png',

  r700_five_content_3: '../../../static/img/ydtx/r700/r700_word9.png',
  r700_six_content_1: '../../../static/img/ydtx/r700/r700_word10.png',
  /*
   R800
   */
  r800_second_content_0: '../../../static/img/ydtx/R800/R800_bg2.jpg',
  r800_third_content_0: '../../../static/img/ydtx/R800/R800_bg3.jpg',
  r800_third_content_1: '../../../static/img/ydtx/R800/r800_word1.png',
  r800_four_content_0: '../../../static/img/ydtx/R800/R800_bg4.jpg',
  r800_five_content_0: '../../../static/img/ydtx/R800/R800_bg5.jpg',
  r800_seven_content_1: '../../../static/img/ydtx/R800/r800_word2.png',
  r800_eight_content_1: '../../../static/img/ydtx/R800/r800_word3.png',
  r800_eight_content_2: '../../../static/img/ydtx/R800/r800_word4.png',
  r800_nine_content_1: '../../../static/img/ydtx/R800/r800_word5.png',
  r800_nine_content_2: '../../../static/img/ydtx/R800/r800_word6.png',
  /*
   F60
   */
  f60_first_content_1: '../../../static/img/ydtx/F60/F60_word1.png',
  f60_first_content_2: '../../../static/img/ydtx/F60/F60_word2.png',
  f60_second_content_1: '../../../static/img/ydtx/F60/F60_word3.png',
  f60_second_content_2: '../../../static/img/ydtx/F60/F60_word4.png',
  f60_third_content_1: '../../../static/img/ydtx/F60/F60_word5.png',
  f60_third_content_2: '../../../static/img/ydtx/F60/F60_word6.png',
  f60_four_content_1: '../../../static/img/ydtx/F60/F60_word7.png',
  /*
   MM570
   */
  mm750_first_content_1: '../../../static/img/ydtx/750/750_word1.png',
  mm750_third_content_0: '../../../static/img/ydtx/750/750_word2.png',
  mm750_third_content_1: '../../../static/img/ydtx/750/750_word3.png',
  mm750_five_content_1: '../../../static/img/ydtx/750/750_word4.png',
  mm750_eight_content_0: '../../../static/img/ydtx/750/750_word5.png',
  /*
   H18
   */
  h18_first_content_1: '../../../static/img/zwtx/H18/H18_word1.png',
  h18_second_content_0: '../../../static/img/zwtx/H18/H18_word2.png',
  h18_third_content_1: '../../../static/img/zwtx/H18/H18_word3.png',
  h18_four_content_1: '../../../static/img/zwtx/H18/H18_word4.png',
  h18_four_content_2: '../../../static/img/zwtx/H18/H18_word5.png',
  h18_four_content_3: '../../../static/img/zwtx/H18/H18_word6.png',
  h18_five_content_1: '../../../static/img/zwtx/H18/H18_word7.png',
  h18_five_content_2: '../../../static/img/zwtx/H18/H18_word8.png',
  h18_five_content_3: '../../../static/img/zwtx/H18/H18_word9.png',
  h18_six_content_0: '../../../static/img/zwtx/H18/H18_word10.png',
  h18_six_content_1: '../../../static/img/zwtx/H18/H18_word11.1.png',
  h18_six_content_2: '../../../static/img/zwtx/H18/H18_word11.2.png',
  h18_six_content_3: '../../../static/img/zwtx/H18/H18_word12.png',
  h18_seven_content_0: '../../../static/img/zwtx/H18/H18_word13.png',
  h18_eight_content_0: '../../../static/img/zwtx/H18/H18_word14.png',
  h18_ten_content_0: '../../../static/img/zwtx/H18/H18_word15.png',
  h18_eleven_content_0: '../../../static/img/zwtx/H18/H18_word16.png',
  h18_eleven_content_1: '../../../static/img/zwtx/H18/H18_word17.png',
  h18_eleven_content_2: '../../../static/img/zwtx/H18/H18_word18.png',
  h18_twelve_content_1: '../../../static/img/zwtx/H18/H18_word19.png',
  h18_thirteen_content_0: '../../../static/img/zwtx/H18/H18_word20.png',
  h18_thirteen_content_1: '../../../static/img/zwtx/H18/H18_word21.png',
  /*
   D30
   */
  d30_first_content_1: '../../../static/img/zwtx/D30/D30_word1.png',
  d30_third_content_0: '../../../static/img/zwtx/D30/D30_word2.png',
  d30_four_content_0: '../../../static/img/zwtx/D30/D30_word3.png',

  /*
   P35
   */
  p35_first_content_1: '../../../static/img/p35/P35_word1.png',
  p35_first_content_2: '../../../static/img/p35/P35_word2.png',
  p35_first_content_3: '../../../static/img/p35/P35_word3.png',
  p35_second_content_1: '../../../static/img/p35/P35_word4.png',
  p35_second_content_2: '../../../static/img/p35/P35_word5.png',
  p35_second_content_3: '../../../static/img/p35/P35_word6.png',
  p35_four_content_0: '../../../static/img/p35/P35_word7.png',
  p35_four_content_1: '../../../static/img/p35/P35_word8.png',
  p35_six_content_1: '../../../static/img/p35/P35_word9.png',
  p35_six_content_2: '../../../static/img/p35/P35_word10.png',
  p35_six_content_3: '../../../static/img/p35/P35_word10.1.png',
  p35_six_content_4: '../../../static/img/p35/P35_word11.png',
  p35_eight_content_1: '../../../static/img/p35/P35_word12.png',
  p35_eight_content_2: '../../../static/img/p35/P35_word13.png',
  /*
   企业资讯
   */
  qyzx_first_li: "企业简介",
  qyzx_second_li: "发展历程",
  qyzx_third_li: "合作伙伴",
  qyzx_four_li: "合作方式",
  qyzx_five_li: "质量认证",
  qyzx_six_li: "联系我们",
  qyzx_first_content_1: '../../../static/img/qyzx/about_us_word1.png',
  qyzx_second_content_0: '../../../static/img/qyzx/about_us_word2.png',
  qyzx_second_content_1: '../../../static/img/qyzx/about_us_word3.png',
  qyzx_second_content_2: '../../../static/img/qyzx/about_us_word4.png',
  qyzx_second_content_3: '../../../static/img/qyzx/about_us_word5.png',
  qyzx_third_content_0: '../../../static/img/qyzx/about_us_word6.png',
  qyzx_third_content_1: '../../../static/img/qyzx/about_us_word7.png',
  qyzx_third_content_2: '../../../static/img/qyzx/about_us_word8.png',
  qyzx_third_content_3: '../../../static/img/qyzx/about_us_word9.png',
  qyzx_four_content_0: '../../../static/img/qyzx/about_us_word10.png',
  qyzx_four_content_1: '../../../static/img/qyzx/about_us_word11.png',
  qyzx_five_content_0: '../../../static/img/qyzx/about_us_word12.png',
  qyzx_six_content_0: '../../../static/img/qyzx/about_us_word13.jpg',
  qyzx_six_content_1: '../../../static/img/qyzx/about_us_word14.jpg',
  qyzx_six_content_2: '../../../static/img/qyzx/about_us_word15.jpg',
  /*
   合作伙伴
   */
  hzhb_first_content_0: '../../../../static/img/qyzx/hzhb/Partner1.png',
  hzhb_first_content_1: '../../../../static/img/qyzx/hzhb/Partner2.png',
  /*
   合作方式
   */

  hzfs_first_content_0:'../../../../static/img/qyzx/hzfs/cooperation_method_word1.png',

  hzfs_second_text_content_1: '整机设计方案',
  hzfs_second_text_content_2: '提供从外形（外观）、结构、软件、硬件到生产线搭建在内的全套产品解决方案。并以低成本、高效率、为客户提供全套产品的设计服务及技术支持，帮助客户降低成本，缩短上市时间，抢占市场先机。',
  hzfs_second_text_content_3: '提供主板（PCBA）',
  hzfs_second_text_content_4: '提供完整的PCBA板，协助客户进行其他相关物料的采购、组装，测试并提供全程技术支持。',
  hzfs_second_text_content_5: 'ODM',
  hzfs_second_text_content_6: '根据客户需求提供全套的设计方案及全程技术支持，帮助客户组织材料采购、生产测试，直到产品顺利量产。',


  /**
   * 发展历程
   */


  hzfs_img_first_content_1: "../../../../static/img/qyzx/fzlc/development_path_word2.png",
  hzfs_img_first_content_2: "../../../../static/img/qyzx/fzlc/development_path_word3.png",
  hzfs_img_first_content_3: "../../../../static/img/qyzx/fzlc/development_path_word4.png",


  hzfs_img_second_content_1: "../../../../static/img/qyzx/fzlc/development_path_word7.png",
  hzfs_img_second_content_2: "../../../../static/img/qyzx/fzlc/development_path_word8.png",
  hzfs_img_second_content_3: "../../../../static/img/qyzx/fzlc/development_path_word9.png",
  hzfs_img_second_content_4: "../../../../static/img/qyzx/fzlc/development_path_word10.png",

  hzfs_img_third_content_1: "../../../../static/img/qyzx/fzlc/development_path_word13.png",
  hzfs_img_third_content_2: "../../../../static/img/qyzx/fzlc/development_path_word14.png",

  hzfs_img_four_content_1: "../../../../static/img/qyzx/fzlc/development_path_word17.png",
  hzfs_img_four_content_2: "../../../../static/img/qyzx/fzlc/development_path_word18.png",
  hzfs_img_four_content_3: "../../../../static/img/qyzx/fzlc/development_path_word19.png",
  hzfs_img_four_content_4: "../../../../static/img/qyzx/fzlc/development_path_word20.png",
  hzfs_img_four_content_5: "../../../../static/img/qyzx/fzlc/development_path_word21.png",

  // hzfs_text_first_content_1: "与MTK和英飞凌建立合作",
  // hzfs_text_first_content_2: "与全球第一大老人机品牌emporia建立合作关系并持续合作至今",
  // hzfs_text_first_content_3: "首款双面双系统手机上市（MTK+英飞凌）",
  // hzfs_text_first_content_4: "与桑菲合作的首款厚薄电池手机F11上市",

  // hzfs_text_first_content_5: "与FOXCONN深度合作",
  // hzfs_text_first_content_6: "与康佳集团深度合作",
  // hzfs_text_first_content_7: "与俄罗斯品牌FLY深度合作",
  // hzfs_text_first_content_8: "与嘉兰图设计公司一起推出新一代老人手机CP09",

  // hzfs_text_first_content_9: "与国内一线品牌联想,中兴, 唯科等深度合作",
  // hzfs_text_first_content_10: "老人手机CP09荣获IF设计大奖",
  // hzfs_text_first_content_11: "与LAVA,LEMON合作产品上市",
  // hzfs_text_first_content_12: "与emporia合作老人机被评为欧洲最畅销手机",
  // hzfs_text_first_content_13: "参加香港电子展和韩国消费电子展",



  // hzfs_text_second_content_1: "与TCL合作的首款翻盖老人机上市",
  // hzfs_text_second_content_2: "与德国品牌simvally合作",
  // hzfs_text_second_content_3: "与医院合作,推出首款行业定制产品BN430",
  // hzfs_text_second_content_4: "与法国老人服务机构datacet推出D7000",
  // hzfs_text_second_content_5: "参加香港电子展和德国Cebit",

  // hzfs_text_second_content_6: "Simdo首款产品I56上市",
  // hzfs_text_second_content_7: "建立自己的生产线",
  // hzfs_text_second_content_8: "与波兰品牌MAXCOM建立首次合作",
  // hzfs_text_second_content_9: "参加香港电子展和巴塞罗那电子展",

  // hzfs_text_second_content_10: "全年推出自有品牌手机20多款,覆盖10000多个乡镇网点",
  // hzfs_text_second_content_11: "搭建自己智能手机研发团队",
  // hzfs_text_second_content_12: "与西班牙SAIWIRELESS合作",
  // hzfs_text_second_content_13: "推出全新定位和防跌倒产品MIMOV",

  // hzfs_text_second_content_14: "推出自己首款MTK6513平台智能手机",
  // hzfs_text_second_content_15: "与中国移动建立合作,推出自己首款TD定制机",
  // hzfs_text_second_content_16: "与法国kapsys合作推出首款智老人机KAPPHONE",
  // hzfs_text_second_content_17: "参加香港电子展",



  // hzfs_text_third_content_1: "与emporia,MAXCOM等一些列欧洲本地品牌合作",
  // hzfs_text_third_content_2: "推出全新一代老人手机",
  // hzfs_text_third_content_3: "首款安防警用产品基站信息采集仪上市",
  // hzfs_text_third_content_4: "参加香港电子展",

  // hzfs_text_third_content_5: "移动医疗首款世界体积最小血压计问世",
  // hzfs_text_third_content_6: "二代基站信息采集仪上市,在安防警用领域取得巨大成功",
  // hzfs_text_third_content_7: "首款3G老人机在欧洲上市,并成功打入美洲市场",
  // hzfs_text_third_content_8: "与国内养老机构久久颐康合作推出具有健康监测和搭载",
  // hzfs_text_third_content_9: "具有老人特色后台服务平台系统的老人手机",
  // hzfs_text_third_content_10: "搭建自己的移动APP研发团队",
  // hzfs_text_third_content_11: "参加香港电子展",



  // hzfs_text_four_content_1: "深圳心派科技正式成立",
  // hzfs_text_four_content_2: "三代全网通基站信息采集仪上市",
  // hzfs_text_four_content_3: "智能老人机三代搭载全新老人系统和光电",
  // hzfs_text_four_content_4: "健康监测功能问世",
  // hzfs_text_four_content_5: "移动医疗心电监测产品问世",
  // hzfs_text_four_content_6: "参加香港电子展",

  // hzfs_text_four_content_7: "第一代无线信号分析仪上市",
  // hzfs_text_four_content_8: "参加香港春秋季电子展",

  // hzfs_text_four_content_9: "安防领域客户不断扩大，全采仪和信号分析仪取得良好市场反馈",
  // hzfs_text_four_content_10: "5G路测和无线信号设备投入研发",
  // hzfs_text_four_content_11: "参加春秋季香港电子展",

  // hzfs_text_four_content_12: "5G支持NSA/SA路测成功上市",



}



// WEBPACK FOOTER //
// ./src/common/lang/zh.js